import type { BlogStrings } from "../../types";

export const blog: BlogStrings = {
  index: {
    title: "Blog",
    subtitle: "Releases, notas de diseño e historias de cómo construimos CATE.",
    empty: "Todavía no hay publicaciones. Vuelve pronto.",
    latest: "Lo más reciente",
    releases: "Releases",
    releasesAll: "todas →",
    pastArticles: "Artículos anteriores",
    pastHint: "arrastra para reordenar · haz clic para abrir",
  },
  post: {
    back: "← Blog",
    by: "Por",
    morePosts: "← Más publicaciones",
    keepReading: "Sigue leyendo",
    notFoundTitle: "Publicación no encontrada",
    notFoundBody: "Esta publicación no existe o puede que la hayamos movido.",
    notFoundBack: "← Volver al blog",
  },
  release: {
    notFoundTitle: "Release no encontrada",
    notFoundBody: "No hay ninguna release que coincida con la v{version}.",
    notFoundBack: "← Volver al blog",
    whatsIn: "Qué incluye esta release",
    download: "Descargar v{version}",
    readStory: "Leer la historia completa →",
    levelMajor: "Release mayor",
    levelMinor: "Release menor",
    levelPatch: "Parche",
  },
};
